/** Wire shapes for the Stripe Quote Generator — see apps/api/src/app/stripe-quote/stripe-quote.types.ts. */

export interface SqPlan {
  alias: string;
  name: string;
  unitAmountMinor?: number | null;
  minScreens: number;
}

export interface SqAddOn {
  key: string;
  label: string;
  quantified: boolean;
  tiers: string[];
  requiresPlan: string[];
  unitAmountMinor?: number | null;
}

export interface SqHardware {
  sku: string;
  stripePriceId: string;
  name: string;
  unitAmountMinor?: number | null;
  quotable: boolean;
}

export interface SqCoupon {
  couponKey: string;
  label: string;
  discountSummary?: string | null;
}

export interface SqCatalog {
  plans: SqPlan[];
  addOns: SqAddOn[];
  hardware: SqHardware[];
  coupons: SqCoupon[];
  couponsUnavailable: boolean;
  freightConfigured: boolean;
  stripeReady: boolean;
}

export interface SqCustomer {
  id: string;
  name?: string | null;
  email?: string | null;
  currency?: string | null;
  country?: string | null;
  addressSummary?: string | null;
  customerCoupon?: string | null;
  warnings: string[];
}

export interface SqPreviewLine {
  kind: 'plan' | 'enterprise' | 'addon' | 'hardware' | 'shipping';
  label: string;
  quantity: number;
  unitAmountMinor?: number | null;
  amountMinor?: number | null;
  recurring: boolean;
  couponKey?: string | null;
  couponLabel?: string | null;
  discountMinor: number;
}

export interface SqPreview {
  customer: SqCustomer;
  lines: SqPreviewLine[];
  recurringSubtotalMinor: number;
  recurringDiscountMinor: number;
  oneTimeSubtotalMinor: number;
  totalBeforeTaxMinor: number;
  incomplete: boolean;
}

export interface SqResult {
  quoteId: string;
  number?: string | null;
  status: string;
  amountTotalMinor: number;
  amountTaxMinor: number;
  currency: string;
  expiresAt?: number | null;
  dashboardUrl: string;
  recorded: boolean;
  finalizeError?: string | null;
}

export interface SqRecord {
  quoteId: string;
  number?: string | null;
  stripeCustomerId: string;
  customerName?: string | null;
  status: string;
  amountTotalMinor?: number | null;
  currency: string;
  expiresAt?: string | null;
  createdBy: string;
  createdAt: string;
  lastError?: string | null;
  dashboardUrl: string;
}

export interface SqInput {
  stripeCustomerId: string;
  plan?: string;
  screens?: number;
  planCouponKey?: string;
  addOns?: { key: string; quantity?: number; tier?: string; couponKey?: string }[];
  hardware?: { sku: string; stripePriceId?: string; quantity: number }[];
  description?: string;
  footer?: string;
}

export const ENTERPRISE = 'enterprise';
export const NONE = 'none';

export function usd(minor: number | null | undefined): string {
  if (minor == null) return '—';
  return (minor / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
